/* ============================================
   SALES POPUP - Conversion Notification Engine
   ============================================ */
(function() {
  'use strict';

  /* --- Configuration --- */
  var CONFIG = {
    MAX_POPUPS: 12,
    VISIBLE_DURATION: 5000,
    INITIAL_DELAY_MIN: 8000,
    INITIAL_DELAY_MAX: 15000,
    DESKTOP_INTERVAL_MIN: 20000,
    DESKTOP_INTERVAL_MAX: 45000,
    MOBILE_INTERVAL_MIN: 35000,
    MOBILE_INTERVAL_MAX: 60000,
    MOBILE_BREAKPOINT: 768
  };

  var NAMES = [
    'Maryam','Ayesha','Hira','Sana','Mahnoor','Zoya',
    'Iqra','Eman','Alina','Mehak','Noor','Dua','Komal','Anaya'
  ];

  var CITIES = [
    'Lahore','Karachi','Islamabad','Rawalpindi','Faisalabad',
    'Multan','Gujranwala','Sialkot','Peshawar','Hyderabad'
  ];

  /* Weighted: smaller times appear more often */
  var TIMES = [
    {t:'Just now',w:20},{t:'2 minutes ago',w:18},{t:'5 minutes ago',w:16},
    {t:'8 minutes ago',w:14},{t:'12 minutes ago',w:11},{t:'17 minutes ago',w:8},
    {t:'24 minutes ago',w:5},{t:'32 minutes ago',w:4},{t:'41 minutes ago',w:2},
    {t:'1 hour ago',w:2}
  ];

  /* --- Blocked pages --- */
  var BLOCKED = ['/cart','/checkout','/account','/contact','/policies','/pages/contact'];

  /* --- State --- */
  var popupCount = 0;
  var isVisible = false;
  var tabActive = true;
  var addedToCart = false;
  var timer = null;
  var hideTimer = null;
  var products = [];
  var shownKeys = [];
  var el = null;

  /* --- Utilities --- */
  function isMobile() { return window.innerWidth <= CONFIG.MOBILE_BREAKPOINT; }

  function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

  function weightedPick(arr) {
    var total = 0;
    for (var i = 0; i < arr.length; i++) total += arr[i].w;
    var r = Math.random() * total;
    for (var j = 0; j < arr.length; j++) {
      r -= arr[j].w;
      if (r <= 0) return arr[j].t;
    }
    return arr[0].t;
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = rand(0, i);
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function shouldBlock() {
    var path = window.location.pathname.toLowerCase();
    for (var i = 0; i < BLOCKED.length; i++) {
      if (path.indexOf(BLOCKED[i]) === 0) return true;
    }
    if (path.indexOf('/pages/') === 0) return true;
    var tpl = (window.Shopify && window.Shopify.template) || '';
    if (tpl === 'cart' || tpl === 'customers') return true;
    return false;
  }

  function getSessionData() {
    try {
      var d = sessionStorage.getItem('sp_shown');
      return d ? JSON.parse(d) : [];
    } catch(e) { return []; }
  }

  function saveSessionData(arr) {
    try { sessionStorage.setItem('sp_shown', JSON.stringify(arr)); } catch(e) {}
  }

  function getSessionCount() {
    try { return parseInt(sessionStorage.getItem('sp_count') || '0', 10); } catch(e) { return 0; }
  }

  function incrSessionCount() {
    try { sessionStorage.setItem('sp_count', String(getSessionCount() + 1)); } catch(e) {}
  }

  /* --- Build popup DOM --- */
  function createPopupElement() {
    var d = document.createElement('div');
    d.className = 'sp-popup';
    d.setAttribute('role', 'status');
    d.setAttribute('aria-live', 'polite');
    d.innerHTML =
      '<a class="sp-inner" href="#" target="_self">' +
        '<div class="sp-img-wrap"><img src="" alt="" loading="lazy" width="64" height="64"></div>' +
        '<div class="sp-content">' +
          '<p class="sp-title"></p>' +
          '<p class="sp-product"></p>' +
          '<div class="sp-meta">' +
            '<span class="sp-time"></span>' +
            '<span class="sp-verified">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
              'Verified' +
            '</span>' +
          '</div>' +
        '</div>' +
      '</a>' +
      '<button class="sp-close" aria-label="Close notification">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="sp-progress"></div>';
    document.body.appendChild(d);
    d.querySelector('.sp-close').addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      hidePopup();
    });
    return d;
  }

  /* --- Generate unique combination --- */
  function generateCombo() {
    shownKeys = getSessionData();

    if (shownKeys.length >= products.length * NAMES.length) {
      shownKeys = [];
      saveSessionData(shownKeys);
    }

    var attempts = 0;
    var combo;

    while (attempts < 200) {
      var p = products[rand(0, products.length - 1)];
      var n = NAMES[rand(0, NAMES.length - 1)];
      var c = CITIES[rand(0, CITIES.length - 1)];
      var t = weightedPick(TIMES);
      var key = p.id + '|' + n + '|' + c + '|' + t;

      if (shownKeys.indexOf(key) === -1) {
        combo = { product: p, name: n, city: c, time: t, key: key };
        break;
      }
      attempts++;
    }

    if (!combo) {
      shownKeys = [];
      saveSessionData(shownKeys);
      var p2 = products[rand(0, products.length - 1)];
      combo = {
        product: p2,
        name: NAMES[rand(0, NAMES.length - 1)],
        city: CITIES[rand(0, CITIES.length - 1)],
        time: weightedPick(TIMES),
        key: p2.id + '|fresh'
      };
    }

    return combo;
  }

  /* --- Show / Hide --- */
  function showPopup() {
    if (isVisible || addedToCart || !tabActive || shouldBlock()) return;
    if (getSessionCount() >= CONFIG.MAX_POPUPS) return;
    if (products.length === 0) return;

    var combo = generateCombo();
    var p = combo.product;

    var link = el.querySelector('.sp-inner');
    var img = el.querySelector('.sp-img-wrap img');
    var title = el.querySelector('.sp-title');
    var prod = el.querySelector('.sp-product');
    var time = el.querySelector('.sp-time');

    link.href = p.url;
    img.src = p.image;
    img.alt = p.title;
    title.innerHTML = '<strong>' + combo.name + '</strong> from ' + combo.city;
    prod.textContent = 'purchased ' + p.title;
    time.textContent = combo.time;

    var bar = el.querySelector('.sp-progress');
    bar.style.animation = 'none';
    void bar.offsetHeight;
    bar.style.animation = 'sp-countdown ' + (CONFIG.VISIBLE_DURATION / 1000) + 's linear forwards';

    requestAnimationFrame(function() {
      el.classList.remove('sp-hiding');
      el.classList.add('sp-visible');
      isVisible = true;
    });

    shownKeys.push(combo.key);
    saveSessionData(shownKeys);
    incrSessionCount();
    popupCount++;

    hideTimer = setTimeout(hidePopup, CONFIG.VISIBLE_DURATION);
  }

  function hidePopup() {
    if (!isVisible) return;
    clearTimeout(hideTimer);
    el.classList.add('sp-hiding');
    el.classList.remove('sp-visible');
    isVisible = false;

    if (popupCount < CONFIG.MAX_POPUPS && getSessionCount() < CONFIG.MAX_POPUPS && !addedToCart) {
      scheduleNext();
    }
  }

  function scheduleNext() {
    clearTimeout(timer);
    var min, max;
    if (isMobile()) {
      min = CONFIG.MOBILE_INTERVAL_MIN;
      max = CONFIG.MOBILE_INTERVAL_MAX;
    } else {
      min = CONFIG.DESKTOP_INTERVAL_MIN;
      max = CONFIG.DESKTOP_INTERVAL_MAX;
    }
    timer = setTimeout(showPopup, rand(min, max));
  }

  /* --- Event listeners --- */
  function bindEvents() {
    document.addEventListener('visibilitychange', function() {
      tabActive = !document.hidden;
      if (!tabActive) {
        clearTimeout(timer);
        clearTimeout(hideTimer);
      } else if (!isVisible && !addedToCart && popupCount < CONFIG.MAX_POPUPS) {
        scheduleNext();
      }
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[type="submit"][name="add"], .product-form__submit, .add-to-cart, [data-add-to-cart]');
      if (btn) {
        addedToCart = true;
        clearTimeout(timer);
        clearTimeout(hideTimer);
        if (isVisible) hidePopup();
      }
    });
  }

  /* --- Initialize --- */
  function init() {
    if (shouldBlock()) return;
    if (getSessionCount() >= CONFIG.MAX_POPUPS) return;

    try {
      products = JSON.parse(document.getElementById('sp-products-data').textContent);
    } catch(e) { return; }

    if (products.length === 0) return;
    shuffle(products);

    popupCount = getSessionCount();
    el = createPopupElement();
    bindEvents();

    var initDelay = rand(CONFIG.INITIAL_DELAY_MIN, CONFIG.INITIAL_DELAY_MAX);
    timer = setTimeout(showPopup, initDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
